import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class CaveFloor extends Floor {
	static key = "CaveFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): CaveFloor {
		const f = new CaveFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
